var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeaderFooter)?_c('SiteHeader'):_vm._e(),_c('router-view'),(!_vm.$route.meta.hideHeaderFooter)?_c('SiteFooter'):_vm._e(),_c('AuthModal'),_c('VideoPlayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }